import { Check, X } from "lucide-react";

const AGENCY = [
  "You train them on your business and offers.",
  "They may understand marketing — but not the WinCampaign business model.",
  "Lead generation is often an additional service.",
  "Discovery Calls and sales conversations are typically not included.",
  "You manage multiple freelancers or vendors.",
  "No direct access to the team that created the WinCampaign system.",
];

const WINCAMPAIGN = [
  "Built exclusively for WinCampaign Brand Affiliates.",
  "The same marketing strategy used by the WinCampaign founder.",
  "Done-for-you content, lead generation, and business growth support.",
  "Optional Discovery Calls conducted by trained WinCampaign Growth Advisors (ELITE).",
  "One team that already knows your products, offers, and enrollment process.",
  "Built to help you consistently grow your subscriber base and recurring income.",
];

export default function WhyWinCampaign() {
  return (
    <section
      id="why-wincampaign"
      data-testid="wc-why"
      className="bg-[#f8f6ff] py-20 sm:py-28"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white text-[#673dfc] border border-[#e5dfff] font-nav font-semibold text-xs rounded-full px-3 py-1 mb-4">
            Why WinCampaign
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#30265b] leading-[1.1]">
            Don&apos;t hire a marketing agency to learn your business.{" "}
            <span className="text-[#673dfc]">
              Partner with the team that built it.
            </span>
          </h2>
          <div className="mt-5 space-y-4 text-lg text-gray-700 leading-relaxed">
            <p>
              Most freelancers and marketing agencies are experts in marketing.
              We&apos;re experts in growing WinCampaign Brand Affiliate
              businesses.
            </p>
            <p>
              Instead of spending thousands of dollars every month teaching an
              outside agency your products, compensation plan, and sales
              process, partner directly with the WinCampaign team — the same
              team building, testing, and scaling this business every day.
            </p>
            <p className="font-display font-semibold text-[#30265b]">
              This is the exact marketing system our founder uses to grow the
              WinCampaign subscription business.
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-3xl bg-white border border-gray-200 p-8">
            <div className="text-xs font-nav font-semibold uppercase tracking-wider text-gray-500">
              Traditional Marketing Agency or Freelancer
            </div>
            <div className="mt-2 font-display font-bold text-2xl text-[#30265b]">
              Typical investment: $2,000 – $6,000+ / month
            </div>
            <div className="text-sm text-gray-500 mt-1">
              (Depending on services, team size, and scope of work.)
            </div>
            <ul className="mt-6 space-y-3">
              {AGENCY.map((a) => (
                <li key={a} className="flex items-start gap-3 text-sm text-gray-600 leading-relaxed">
                  <span className="w-5 h-5 rounded-full bg-gray-100 grid place-items-center text-gray-400 flex-shrink-0 mt-0.5">
                    <X size={12} />
                  </span>
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative rounded-3xl bg-[#30265b] text-white p-8 border-2 border-[#673dfc] shadow-2xl shadow-[#673dfc]/20">
            <div className="absolute -top-3 left-8 bg-[#d3fc3a] text-[#1a1a24] text-[10px] font-display font-bold uppercase tracking-wider py-1 px-3 rounded-full">
              Built for you
            </div>
            <div className="text-xs font-nav font-semibold uppercase tracking-wider text-[#d3fc3a]">
              WinCampaign DFY Business Growth Accelerator
            </div>
            <div className="mt-2 font-display font-bold text-2xl">
              Starting at just $348 / month
            </div>
            <ul className="mt-6 space-y-3">
              {WINCAMPAIGN.map((w) => (
                <li key={w} className="flex items-start gap-3 text-sm text-white/90 leading-relaxed">
                  <span className="w-5 h-5 rounded-full bg-[#d3fc3a] text-[#1a1a24] grid place-items-center flex-shrink-0 mt-0.5">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  <span>{w}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Closing statement */}
        <div className="mt-10 max-w-3xl mx-auto text-center">
          <p className="font-display font-semibold text-xl sm:text-2xl text-[#30265b] leading-snug">
            Instead of hiring someone to learn your business, partner with the
            team that built it.
          </p>
          <p className="mt-3 text-gray-600 text-base sm:text-lg leading-relaxed">
            That&apos;s the difference between outsourcing marketing and
            partnering with WinCampaign.
          </p>
        </div>
      </div>
    </section>
  );
}
